import * as React from 'react';
import styled from 'styled-components';
import { Product, WishlistHelper, ClickoutProps, ClickoutArea } from '@packages/common';

import { ProductTileTop } from './productTileTop';
import { ProductTileBottom } from './productTileBottom';
import { productTileBottomHeight } from './utils/HeightCalculator';

const Container = styled.div`
  width: 100%;
  box-shadow: rgba(43, 18, 2, 0.06) 0px 0px 5px 3px;
`;
interface ProductTileProps {
  product: Product;
  index: number;
  isLocallyFiltered: boolean;
  wishlistHelper: WishlistHelper;
  showPartnerName?: boolean;
  hideShippingInfo?: boolean;
  hidePromotionsOnXS?: boolean;
  Clickout: React.FC<ClickoutProps>;
  sorted: boolean;
}

export const ProductTile: React.FC<ProductTileProps> = React.memo(
  ({
    product,
    index,
    isLocallyFiltered,
    wishlistHelper,
    Clickout,
    sorted,
    showPartnerName = false,
    hideShippingInfo = false,
    // TODO: when 3 layout column is wins the A/B test remove this and update css for `PromotionFlags`
    hidePromotionsOnXS = false,
  }) => {
    return (
      <Container data-testid={`product-tile-${index}`}>
        <Clickout sorted={sorted} product={product} area={ClickoutArea.PRODUCT_TILE_IMAGE} index={index}>
          <ProductTileTop
            index={index}
            sorted={sorted}
            product={product}
            wishlistHelper={wishlistHelper}
            hidePromotionsOnXS={hidePromotionsOnXS}
          />
        </Clickout>
        <Clickout sorted={sorted} product={product} index={index} area={ClickoutArea.OTHER}>
          <ProductTileBottom
            product={product}
            isLocallyFiltered={isLocallyFiltered}
            bottomHeight={productTileBottomHeight}
            showPartnerName={showPartnerName}
            hideShippingInfo={hideShippingInfo}
          />
        </Clickout>
      </Container>
    );
  },
);

ProductTile.displayName = 'ProductTile';
